<template>
  <DashboardLayout>

    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <p class="mb-0 main-identifier fw-semibold">MDA</p>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">Create Sector</p>
    </div>

    <div class="d-flex justify-content-center">
      <div class="form-outer">
        <form @submit.prevent="handleSubmit">
          <div class="crud-form position-relative">

            <div class="form-inner">

              <div class="form-header d-flex justify-content-between align-items-center">
                  <h1 class="mb-0">Sector</h1>
              </div>

              <!-- <p v-if="errorMessage" class="text-danger">{{ errorMessage }}</p> -->

            <div class="form-body">
              <div class="row mt-2 mb-3">
              <div class="col-md-12 row form-group position-relative floating-label-group">
                <div class="col-md-2 label-left d-flex justify-content-end align-items-center"><label for="name" class="form-label">Sector Code</label></div>
                <div class="col-md-10 input-right"><input type="text" class="form-control" v-model="sectorCode" placeholder="Enter Sector Code" required></div>
              </div>

              <div class="col-md-12 row form-group position-relative floating-label-group">
                <div class="col-md-2 label-left d-flex justify-content-end align-items-center"><label for="description" class="form-label">Description</label></div>
                <div class="col-md-10 input-right">
                  <textarea
                    class="form-control"
                    id="description"
                    v-model="description"
                    placeholder=""
                    rows="3"
                    required
                  ></textarea>
                </div>
              </div>
              </div>

              <div class="d-flex justify-content-center">
                  <button class="submit-btn" type="submit" :disabled="isLoading">
                      <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      {{ isLoading ? 'Submitting...' : 'Submit' }}
                  </button>
              </div>
            </div>
          </div>
        </div>
        </form>
      </div>
    </div>

  </DashboardLayout>
</template>

<script setup>
  import axios from 'axios';
  import Cookies from 'js-cookie';
  import { ref, onMounted } from 'vue';
  import DashboardLayout from '../layout/DashboardLayout.vue';
  import Swal from 'sweetalert2'

  const sectorCode = ref('');
  const description = ref('');

  const isLoading = ref(false);
  const errorMessage = ref('');

  const root_api_url = process.env.VUE_APP_API_ROOT_URL;

  async function handleSubmit() {
      const token = Cookies.get('auth_token');

      if (!token) {
      alert('You must be logged in to perform this action.');
      return;
      }

      const sectorData = {
        sectorCode: sectorCode.value.trim(),
        description: description.value.trim(),
      };

      const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
      const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

      isLoading.value = true;
      errorMessage.value = '';

      try {
          const response = await axios.post(`${root_api_url}/eli/sector`, sectorData, {
              headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
              },
          });

          if (response.status === 200 || response.status === 201) {
              // alert('Sector created successfully!');
              Swal.fire({
                // title: 'Success!',
                html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>Sector created successfully!</p> `,
                showConfirmButton: true,
                showCloseButton: true,
                icon: undefined,
              });
              sectorCode.value = '';
              description.value = '';
          } else {
              errorMessage.value = 'Failed to create sector.';
              Swal.fire({
                html: `${iconHtmlError}
                <h1 style="font-weight:600;">Error</h1>
                <p>${errorMessage.value}</p>`,
                showConfirmButton: true,
                showCloseButton: true,
                icon: undefined,
              });
              // alert(errorMessage.value);
          }
      } catch (err) {
      if (err?.response?.status === 400) {
              errorMessage.value = err?.response?.data?.errorMessage || err?.response?.data?.error || err?.response?.data?.message || 'Invalid data provided.';
          } else if (err?.response?.status === 401) {
              errorMessage.value = 'Unauthorized. Please log in again.';
          } else if (err?.response?.status === 503) {
              errorMessage.value = 'Service unavailable. Please try again later.';
          } else {
              errorMessage.value = 'Unexpected error occurred, kindly contact administrator.';
          }
          Swal.fire({
              html: `${iconHtmlError}
              <h1 style="font-weight:600;">Error</h1>
              <p>${errorMessage.value}</p>`,
              showConfirmButton: true,
              showCloseButton: true,
              icon: undefined,
            });
          // alert(errorMessage.value);
      } finally {
          isLoading.value = false;
      }
  }

  onMounted(() => {
    document.title = "Create Sector"
  })
</script>
